export function appendToBody(node) {
    const parent = node.parentElement;
    document.body.append(node);
    return {
        destroy() {
            parent.append(node);
        },
    };
}
